// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"b5bb2c84","1831":"b97bb3c8","3975":"8effa155","8181":"06d108b5"}[chunkId] + ".chunk.css";
};